import { Controller } from "@hotwired/stimulus"

// Un dato del decreto (Dato di components/rendicontazione/Decreto.js, 31a5bd1): «Scrivi» / «Correggi» apre l'editor
// (valore e frase, ripartono dal dato confermato o dalla proposta: apri() = setValore(dato?.valore ?? proposta?.valore),
// setFrase(...)) e nasconde i pulsanti e la riga del decreto (`!modifica`); «Chiudi» li riporta. L'editor è un form che
// invia il server (la scheda si riscrive e l'editor si chiude da sé; un errore lo lascia aperto).
export default class extends Controller {
  static targets = ["azioni", "fonte", "editor", "form"]

  apri() {
    this.formTarget.reset() // i valori dell'HTML sono quelli iniziali
    this.mostra(true)
  }

  chiudi() {
    this.mostra(false)
  }

  mostra(aperto) {
    this.azioniTargets.forEach((el) => { el.hidden = aperto })
    this.fonteTargets.forEach((el) => { el.hidden = aperto })
    this.editorTarget.hidden = !aperto
  }
}
